module.exports = __webpack_public_path__ + "static/img/ChamberMusic.b10bde4.b10bde48.jpg";